import React from 'react';
import { motion } from 'framer-motion';
import { Users, FileCheck, Star } from 'lucide-react';
export function SocialProofStrip() {
  const stats = [{
    icon: Users,
    text: '+3.000 docentes confían',
    color: 'text-blue-400'
  }, {
    icon: FileCheck,
    text: 'Más de 200 actividades listas para usar',
    color: 'text-green-400'
  }, {
    icon: Star,
    text: '4.9/5 calificación promedio',
    color: 'text-[#FBBF24]'
  }];
  const testimonials = [{
    name: 'Carlos Méndez',
    age: 38,
    location: 'Santiago, Chile',
    quote: 'En una tarde pude organizar todas mis clases del trimestre.',
    initial: 'C',
    color: 'bg-blue-600'
  }, {
    name: 'Mariana López',
    age: 41,
    location: 'Bogotá, Colombia',
    quote: 'Las actividades funcionan increíble con mis alumnos.',
    initial: 'M',
    color: 'bg-pink-600'
  }, {
    name: 'Luis Herrera',
    age: 35,
    location: 'Ciudad de México, México',
    quote: 'Ahora llego a la clase con todo preparado.',
    initial: 'L',
    color: 'bg-green-600'
  }];
  return <section className="py-12 bg-[#143524] border-y border-[#1E4D2B]" data-id="element-389">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-390">
        {/* Stats Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-391">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center justify-center text-center p-6 bg-[#0C2818] rounded-2xl border border-[#1E4D2B]" data-id="element-392">
              <stat.icon className={`w-8 h-8 ${stat.color} mb-3`} data-id="element-393" />
              <span className="text-white font-bold text-lg" data-id="element-394">{stat.text}</span>
            </motion.div>)}
        </div>

        <div className="text-center mb-8" data-id="element-395">
          <p className="text-[#FBBF24] font-semibold uppercase tracking-wider text-sm" data-id="element-396">
            Docentes de educación física de toda Latinoamérica
          </p>
        </div>

        {/* Testimonials Row */}
        <div className="flex overflow-x-auto md:grid md:grid-cols-3 gap-6 pb-4 md:pb-0 snap-x" data-id="element-397">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1 + 0.3
        }} className="min-w-[280px] md:min-w-0 flex-1 bg-[#0C2818] p-6 rounded-2xl border border-[#1E4D2B] snap-center" data-id="element-398">
              <div className="flex gap-1 text-[#FBBF24] mb-4" data-id="element-399">
                {[...Array(5)].map((_, starI) => <Star key={starI} className="w-4 h-4 fill-current" data-id="element-400" />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-401">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-402">
                <div className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center text-white font-bold`} data-id="element-403">
                  {t.initial}
                </div>
                <div data-id="element-404">
                  <p className="text-white font-bold text-sm" data-id="element-405">{t.name}</p>
                  <p className="text-gray-500 text-xs" data-id="element-406">
                    {t.age} años, {t.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}